import React from 'react'
import { Table, Button, message, Modal, Row, Col, Spin } from 'antd'
import '../../css/patient.scss'
import moment from 'moment'
import { lowerFirst } from 'lodash'

const DEVICES_STATUS={
  PENDING:'Pending',
  UNLINKED:'Unlinked',
  FAIL:'fail'
}
const { confirm ,error} = Modal
const DeviceStatus = ({
  assigneddevices,
  reOrderDeviceSchedule,
  showDeviceModal,
  getPatient,
  isLoading
}) => {
  const filterassigneddevices = assigneddevices.filter(
    (device) => device.isDeleted == false
  )

  const isDisable = (status)=>{
     return [DEVICES_STATUS.PENDING, DEVICES_STATUS.UNLINKED,DEVICES_STATUS.FAIL].includes(status);
  }
  function showConfirm(obj) {
    if(isDisable(obj.status)){
     error({
       title:`Order status is in ${lowerFirst(obj.status)} state`,
        okText: 'OK',
        onOk() {},
     })
    }
  else{
    confirm({
      title: 'Do you want to reorder device?',
      async onOk() {
        try {
          await handleDeviceReorder(obj)
        } catch (e) {
          return console.log(' errors!')
        }
      },
      onCancel() {},
    })
  }
  }

  var handleDeviceReorder = async (obj) => {
    var assigneddevices_new = []
    for (var i = 0; i < assigneddevices.length; i++) {
      assigneddevices_new.push({
        _id: assigneddevices[i].deviceid,
        name: assigneddevices[i].name,
        display_name: assigneddevices[i].display_name,
        media: {
          image: {
            url: assigneddevices[i].media.image.url,
          },
        },
        isDeleted: assigneddevices[i].deviceid == obj.deviceid ? true : false,
        scheduled_criteria: {
          start_date: 0,
          end_date: 0,
          time: 0,
        },
        status: assigneddevices[i].status,
      })
    }

    // console.log('handleDeviceReorder', assigneddevices_new)
    var response = await reOrderDeviceSchedule(assigneddevices_new)
    showDeviceModal()
   if(response) getPatient();
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'display_name',
      align: 'center',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      align: 'center',
    },
    {
      title: 'Track Link',
      dataIndex: 'tracking_link',
      align: 'center',
      render: (text) =>
        text ? (
          <a href={text} target='_blank' rel='noopener noreferrer'>
            {text}{' '}
          </a>
        ) : (
          'NA'
        ),
    },
    {
      title: 'Shipped On',
      dataIndex: 'shipped_on',
      align: 'center',
      render: (date) =>
        date ? moment(date).format('MM/DD/YYYY, h:mm a').toString() : 'NA',
    },
    {
      title: 'Delivered On',
      dataIndex: 'delivered_on',
      align: 'center',
      render: (date) =>
        date ? moment(date).format('MM/DD/YYYY, h:mm a').toString() : 'NA',
    },
    {
      title: 'Action',
      dataIndex: 'Action',
      align: 'center',
      render: (e, obj) => (
        <div className='reorder-container'>
          <Button
            type='link'
            onClick={() => {
              showConfirm(obj)
            }}
          >
            reorder
          </Button>
          {obj.reorder_on && (
            <div className='reorder-date'>
              <Row>
                {/* <Col>Last success:</Col> */}
                <Col span={2}>
                  {/* {moment(obj.reorder_on)
                    .format('MM/DD/YYYY, h:mm a')
                    .toString()} */}
                </Col>
              </Row>
            </div>
          )}
        </div>
      ),
    },
  ]

  return (
    <Spin spinning={isLoading}>
    <div className='device-status'>
      <Table
        columns={columns}
        bordered={true}
        dataSource={filterassigneddevices}
        rowKey={(record) => record.deviceid}
        pagination={false}
        className='table'
      />
    </div>
    </Spin>
  )
}

export default DeviceStatus
